import React from 'react';
import { ColoredIcon, SynchronizationIcon } from "../../icon";
import { IconSize } from "../../../enums";
import { SyncSymbolStyled } from "./Field.styles";
import TestIds from "../../../testIds";

interface IProps {
}

const SyncSymbol: React.FC<IProps> = () => {
    return (
            <SyncSymbolStyled data-testid={TestIds.InputSyncSymbol}>
                <ColoredIcon>
                    <SynchronizationIcon width={IconSize.XS} height={IconSize.XS}/>
                </ColoredIcon>
            </SyncSymbolStyled>
    );
};

export default SyncSymbol;